<template>
  <div
    id="containcore"
    :class="{
      en: $i18n.locale === 'en-US',
    }"
  >
    <div
      id="CoreTechnology1"
      ref="CoreTechnology1"
      :style="{ 'background-image': 'url(' + imageUrl1 + ')' }"
      v-lazy="imageUrl1"
    >
      <div id="text" class="CoreTechnology1text">
        <div id="title" class="pre-wrap">{{ $t("technology").h1 }}</div>
        <div id="text">{{ $t("technology").h2 }}</div>
      </div>
    </div>
    <div
      id="CoreTechnology2"
      ref="CoreTechnology2"
      :style="{ 'background-image': 'url(' + imageUrl2 + ')' }"
      v-lazy="imageUrl2"
    >
      <div
        id="title"
        class="CoreTechnology2text wow animate__animated animate__fadeInUp"
      >
        <div id="text1">{{ $t("technology").h3 }}</div>
        <div id="text2">{{ $t("technology").h4 }}</div>
      </div>
      <div
        id="car"
        class="wow animate__animated animate__fadeInUp"
        style="animation-duration: 1s"
        :style="{ 'background-image': 'url(' + carImg + ')' }"
        v-lazy="imageUrl5"
      ></div>
    </div>
    <div id="CoreTechnology3" ref="CoreTechnology3">
      <div id="Logo" class="wow animate__animated animate__fadeInUp">
        <div id="img">
          <img src="@/static/img/CooperationLogo.png" alt="" />
        </div>
        <div id="title">{{ $t("technology").moudleArr[0] }}</div>
      </div>
      <div
        id="CoreTechnology3Top"
        class="CoreTechnology3text wow animate__animated animate__fadeInUp"
      >
        <div id="text1">{{ $t("technology").moudleArr[1] }}</div>
        <div id="text2" class="pre-wrap">
          <span>{{ $t("technology").moudleArr[2] }}</span
          ><span class="highlight">PlenRay<sup>®</sup></span
          >{{ $t("technology").moudleArr[3] }}
        </div>
        <div id="text3">
          {{ $t("technology").moudleArr[4]
          }}<span
            ><b>{{ $t("technology").moudleArr[5] }}</b>
          </span>
        </div>
      </div>
      <div
        id="CoreTechnology3video"
        class="wow animate__animated animate__fadeInUp"
      >
        <video
          id="video"
          ref="videoPlayerCar"
          controlsList="nodownload"
          :controls="isIn"
          :src="$t('technology').progressCarVideo"
          muted
          autoplay
          x-webkit-airplay="allow"
          x5-video-player-type="h5"
          x5-video-player-fullscreen="true"
        ></video>
      </div>
    </div>
    <div id="CoreTechnology4">
      <div id="center">
        <div
          id="left"
          class="CoreTechnology4video wow animate__animated animate__fadeInUp"
        >
          <video
            id="video"
            controlsList="nodownload"
            loop
            controls
            :src="$t('technology').techVideo"
            muted
            autoplay
            x-webkit-airplay="allow"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
          ></video>
        </div>
        <!-- <div id="left" class="CoreTechnology4video wow animate__animated animate__fadeInUp"
          :style="{ 'background-image': 'url(' + imageUrl3 + ')' }" v-lazy="imageUrl3">
        </div> -->
        <div
          id="right"
          class="CoreTechnology4text wow animate__animated animate__fadeInUp"
          style="animation-duration: 2s"
        >
          <div
            id="text"
            class="wow animate__animated animate__fadeInUp"
            style="animation-duration: 4s"
          >
            <div id="text1">{{ $t("technology").moudleArr[6] }}</div>
            <div id="text2">{{ $t("technology").moudleArr[7] }}</div>
          </div>
        </div>
      </div>
    </div>
    <div id="footerss">
      <FooterComponents></FooterComponents>
    </div>
  </div>
</template>

<script>
import FooterComponents from "@/components/FooterComponents.vue";
import WOW from "wowjs";
export default {
  components: {
    FooterComponents,
  },
  data() {
    return {
      isMicOrMoc: "",
      videoTimer: null,
      isIn: false, //鼠标是否位于播放器内
      imageUrl1: require("@/static/img/coretechnologybanner.png"),
      // imageUrl2: require("@/static/img/coretechnologyCarBg.png"),
      imageUrl2: require("@/static/img/coretechnologyCarBgNoHaveCar.png"),
      // imageUrl3: require("@/static/img/coretechnologyWay.gif"),
      imageUrl4: require("@/static/img/cooperationCarBg.png"),
      imageUrl5: require("@/static/img/coretechnologyCar.png"),
      CoreTechnology1Text: document.getElementsByClassName(
        "CoreTechnology1text"
      ),
      CoreTechnology2Text: document.getElementsByClassName(
        "CoreTechnology2text"
      ),
      CoreTechnology3Text: document.getElementsByClassName(
        "CoreTechnology3text"
      ),
      CoreTechnology4Text: document.getElementsByClassName(
        "CoreTechnology4text"
      ),
      CoreTechnology4Video: document.getElementsByClassName(
        "CoreTechnology4video"
      ),
    };
  },
  computed: {
    carImg() {
      return this.$t("technology").carImg;
    },
  },
  created() {
    const reloadOnOrientationChange = () => {
      const isLandscape = Math.abs(window.orientation) === 90;
      if (isLandscape) {
        location.reload();
      } else {
        location.reload();
      }
    };
    window.addEventListener("orientationchange", reloadOnOrientationChange);
  },
  mounted() {
    this.selfAdaptation();
    const wow = new WOW.WOW({
      live: false,
    });
    wow.init();

    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("windows") !== -1) {
      this.isMicOrMoc = true;
    } else if (userAgent.indexOf("mac os") !== -1) {
      this.isMicOrMoc = false;
    } else {
      this.isMicOrMoc = false;
    }
    //关于我们的视频
    //手机端
    // eslint-disable-next-line no-undef
    if (device.mobile()) {
      //手机端横屏检测
      if (window.orientation === 90 || window.orientation === -90) {
        window.addEventListener("scroll", this.scrolling);
      }
      //手机端横竖屏不检测
      else {
        return;
      }
    }
    //Ipad端
    // eslint-disable-next-line no-undef
    else if (device.ipad()) {
      //Ipad端横屏检测
      if (window.orientation === 90 || window.orientation === -90) {
        window.addEventListener("scroll", this.scrolling);
      }
      //Ipad端竖屏不检测
      else {
        return;
      }
    }
    //电脑端检测
    // eslint-disable-next-line no-undef
    else if (device.desktop()) {
      window.addEventListener("scroll", this.scrolling);
    }
  },
  methods: {
    scrolling() {
      // 滚动条距文档顶部的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const screenHeight =
        this.$refs.CoreTechnology1.offsetHeight +
        this.$refs.CoreTechnology2.offsetHeight;
      //进入这个区域
      if (
        scrollTop >= Math.round(0.5 * screenHeight) &&
        scrollTop <= Math.round(1.5 * screenHeight)
      ) {
        if (this.videoTimer == null) {
          this.videoTimer = null;
          clearTimeout(this.videoTimer);
          this.videoTimer = setTimeout(() => {
            this.$refs.videoPlayerCar.currentTime = 0;
            this.$refs.videoPlayerCar.play();
          }, 500);
        } else if (this.videoTimer !== null) {
          return;
        }
      }
      //离开这个区域
      else {
        clearTimeout(this.videoTimer);
        this.videoTimer = null;
        this.$refs.videoPlayerCar.pause();
        this.$refs.videoPlayerCar.currentTime = 0;
      }
    },
    selfAdaptation() {
      //轮播图的适配
      //手机端的
      // eslint-disable-next-line no-undef
      if (device.mobile()) {
        //横屏
        // eslint-disable-next-line no-empty
        if (window.orientation === 90 || window.orientation === -90) {
        } else {
          // 执行竖屏操作
          this.videoTimer = setTimeout(() => {
            this.$refs.videoPlayerCar.currentTime = 0;
            this.$refs.videoPlayerCar.play();
          }, 500);
        }
        // eslint-disable-next-line no-undef
      } else if (device.ipad()) {
        //横屏
        // eslint-disable-next-line no-empty
        if (window.orientation === 90 || window.orientation === -90) {
        } else {
          //关于我们视频在Ipad端竖屏的时候自动播放
          this.videoTimer = setTimeout(() => {
            this.$refs.videoPlayerCar.currentTime = 0;
            this.$refs.videoPlayerCar.play();
          }, 500);
        }
        // eslint-disable-next-line no-undef, no-empty
      } else if (device.desktop()) {
      }
    },
  },

  beforeDestroy() {
    if (this.$refs.videoPlayerCar.play()) {
      this.$refs.videoPlayerCar.pause();
      this.$refs.videoPlayerCar.currentTime = 0;
    }
    window.removeEventListener("scroll", this.scrolling);
  },
};
</script>

<style scoped lang="scss">
#containcore {
  width: 100%;
  // height: 100%;
  box-sizing: border-box;

  @mixin whar($width, $height, $atio) {
    width: $width;
    height: $height;
    aspect-ratio: $atio;
    box-sizing: border-box;
  }

  @mixin bgar($atio) {
    text-align: center;
    margin-right: 1.5rem;
    aspect-ratio: $atio;
    background-size: cover;
  }

  @mixin display {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @mixin commitaspct {
    opacity: 1;
    width: 50%;
    aspect-ratio: 720/600;
    background-size: contain;
  }

  @mixin fontStyle(
    $fontweight,
    $height,
    $fontSize,
    $lineHeight,
    $letterSpaceing,
    $color
  ) {
    width: fit-content;
    font-weight: $fontweight;
    // height: $height;
    font-size: $fontSize;
    font-style: normal;
    line-height: $lineHeight;
    letter-spacing: $letterSpaceing;
    color: $color;
  }

  #CoreTechnology1 {
    background-size: cover;
    padding: 12.9375rem 0rem 0rem 12.8125rem;
    @include whar(100%, auto, 2880/960);

    #text {
      width: fit-content;
      // height: 7.75rem;
      line-height: 3.875rem;

      #title {
        @include fontStyle(
          600,
          3.875 * 2rem,
          2.5rem,
          3.875rem,
          0.06944rem,
          rgba(255, 255, 255, 0.85)
        );
        // width: 21.875rem;
      }

      #text {
        margin-top: 0.75rem;
        @include fontStyle(
          400,
          2rem,
          1.0625rem,
          2rem,
          0.06944rem,
          rgba(255, 255, 255, 0.65)
        );
      }
    }
  }

  #CoreTechnology2 {
    box-sizing: border-box;
    padding-top: 4.875rem;
    @include whar(100%, auto, 2880/1600);
    background-size: cover;

    #title {
      #text1 {
        @include fontStyle(
          600,
          3.125rem,
          2.25rem,
          3.125rem,
          10px,
          rgba(255, 255, 255, 0.85)
        );
        margin-bottom: 1rem;
        text-align: center;
        width: 100%;
      }

      #text2 {
        @include fontStyle(
          400,
          1.625rem,
          1rem,
          1.625rem,
          10px,
          rgba(255, 255, 255, 0.65)
        );
        text-align: center;
        width: 100%;
      }
    }

    #car {
      margin: auto;
      width: 58.5625rem;
      height: 36.125rem;
      margin-top: 3.625rem;
      /* @include whar(100%, auto, 1874/1156); */
      background-size: cover;

      img {
        width: 100%;
      }
    }
  }

  #CoreTechnology3 {
    width: 100%;
    padding-top: 12rem;
    position: relative;
    box-sizing: border-box;
    background: url("@/static/img/dot_bg1.png") repeat;
    background-color: #0e132c;

    #Logo {
      top: 3.875rem;
      right: 8.5rem;
      display: flex;
      width: 5.5625rem;
      position: absolute;
      flex-direction: column;

      #img {
        height: 4rem;
        width: 4.0625rem;
        align-self: center;

        img {
          width: 4.0625rem;
          object-fit: cover;
        }
      }

      #title {
        flex: 1;
        font-weight: 400;
        width: 5.5625rem;
        font-style: normal;
        font-size: 0.875rem;
        text-align: center;
        color: rgba(255, 255, 255, 0.65);
      }
    }

    #CoreTechnology3Top {
      opacity: 1;
      top: 8rem;
      margin-left: 8.875rem;
      /* background-color: blue; */
      position: absolute;
      z-index: 2;

      #text1,
      #text2 {
        @include fontStyle(
          600,
          3.625rem,
          2.2rem,
          3.625rem,
          0.02em,
          rgba(255, 255, 255, 0.85)
        );
        display: flex;

        .highlight {
          color: rgba(215, 31, 40, 1);
        }
      }

      #text3 {
        margin-top: 1rem;
        @include fontStyle(
          400,
          2.75rem,
          1.25rem,
          2.75rem,
          0.02em,
          rgba(255, 255, 255, 0.5)
        );

        span {
          text-align: center;
          font-size: 1.5rem;
          color: rgba(215, 31, 40, 1);
        }
      }
    }

    #CoreTechnology3video {
      width: 100vw;

      video {
        width: 100%;
      }
    }
  }

  #CoreTechnology4 {
    width: 100%;
    height: 52rem;
    display: flex;
    box-sizing: border-box;
    background: url("@/static/img/dot_bg.png") repeat;

    #center {
      display: flex;
      margin: auto;
      width: 85rem;
      height: 35.25rem;

      #left {
        opacity: 1;
        // width: 49rem;
        aspect-ratio: 16/9;
        background-size: cover;

        #video {
          width: 100%;
          height: 100%;
          object-fit: fill;
        }
      }

      #right {
        text-align: center;
        @include display;
        // height: 28.625rem;
        height: 100%;
        width: 28.625rem;
        border-radius: 4px;
        background-color: #0d152e;
        box-shadow: 0px 1.5rem 2.5rem 0px rgba(12, 12, 12, 0.4);
        backdrop-filter: blur(1.5625rem);

        #text {
          margin: auto;
          display: flex;
          // height: 6.75rem;
          width: fit-content;
          flex-direction: column;
          justify-content: space-between;

          #text1 {
            @include fontStyle(
              600,
              2.5rem,
              2.25rem,
              2.5rem,
              0.02em,
              rgba(255, 255, 255, 0.85)
            );
            margin-bottom: 1.8rem;
          }

          #text2 {
            @include fontStyle(
              400,
              2.75rem,
              1.25rem,
              2.75rem,
              0.02em,
              rgba(255, 255, 255, 0.65)
            );
          }
        }
      }
    }
  }

  #footerss {
    height: 18rem;
  }

  &.en {
    #CoreTechnology1 {
      #title,
      #text {
        letter-spacing: 0 !important;
      }
    }
    #CoreTechnology2 {
      #title {
        #text1,
        #text2 {
          letter-spacing: 0 !important;
        }
      }
    }
    #CoreTechnology3Top {
      #text1,
      #text2,
      #text3 {
        letter-spacing: 0 !important;
      }
    }
    #CoreTechnology4 {
      #right {
        #text {
          #text1,
          #text2 {
            letter-spacing: 0 !important;
            line-height: 1.5 !important;
          }
        }
        // text-align: justify !important;
        padding: 3rem !important;
        box-sizing: border-box !important;
      }
    }
  }
}
</style>
